var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topNav"},[_c('nav',{staticClass:"top"},[_c('a',{staticClass:"commerce",attrs:{"href":"/dashboard","title":"Dashboard"}},[_c('img',{attrs:{"src":require("@/assets/images/circle.png"),"width":"30"}})]),_vm._v(" "),_c('h5',[_vm._v("Eco Cooling")])])])
}]

export { render, staticRenderFns }